import { render, staticRenderFns } from "./MonitoringTags.vue?vue&type=template&id=36e29c84&lang=pug"
import script from "./MonitoringTags.vue?vue&type=script&lang=js"
export * from "./MonitoringTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports